import axiosInstance from '../../redux/axiosInstance';

class UserService {

  deactivateUser(userId){
    return axiosInstance.post(`/user/deactivate/${userId}`);
  }

  activateUser(userId){
    return axiosInstance.post(`/user/activate/${userId}`)
  }

  updateLifecycleStatus(userId, status){
    return axiosInstance.patch(`/admin/user/${userId}/lifecycle-status`, { status });
  }
}

export default new UserService()
